import { Injectable } from '@angular/core';

import { CryptoEncDecService } from './crypto-enc-dec';

/**
 * Secure Storage Helper service
 */
@Injectable({
  providedIn: 'root'
})

export class SecureStorage {
  /**
   * 'constructor'
   */
  constructor(private cryptoSer: CryptoEncDecService) {
  }

  /**
   * set key along with data into local storage
   */
  setKeyData(key: string, data: any) {
    // generate rendom key
    let randomKey = this.cryptoSer.makesoltKey();

    key = this.cryptoSer.encryptData(randomKey, key);
    let keyValue = this.cryptoSer.encryptData(randomKey, JSON.stringify(data));

    sessionStorage.setItem((key + ":" + randomKey), keyValue);
  }
  /**
   * get key data from local storage
   */
  getKeyData(key: string): any {
    let matchedKey = this.findMatchingKey(key)
    if (matchedKey !== "")
      return JSON.parse(matchedKey);
    else {
      return undefined;
    }
  }
  /**
   * remove all key from local storage
   * @example
   * removeAllKey()
   */
  removeAllKey() {
    let allKeys = this.getAllBrowserKey();
    if (allKeys.length > 0) {
      allKeys.forEach(singleKey => {
        sessionStorage.removeItem(singleKey);
      });
    }
  }
  /**
   * remove specific key from local storage
   * @example
   * removeKey('keyname');
   */
  removeKey(keyName: string) {
    let alreadyExistKey = this.isValidKey(keyName);
    if (alreadyExistKey !== "") {
      sessionStorage.removeItem(alreadyExistKey);
    }
  }
  /**
   * Find all Key from browser
   */
  private getAllBrowserKey(): any[] {
    return Object.keys(sessionStorage).reduce(function (obj, str) {
      if (str.indexOf(':') != -1) {
        obj.push(str);
      }
      return obj
    }, []);
  }
  /**
   * find specific key from browser
   */
  private findMatchingKey(actualKey: string): any {
    let spliKey = this.isValidKey(actualKey);
    return spliKey != "" ? this.cryptoSer.decryptData(spliKey.split(':')[1], sessionStorage.getItem(spliKey)) : "";
  }

  /**
   * entered key is valid or not
   */
  private isValidKey(key: string): string {
    let allKeys = this.getAllBrowserKey();

    let validKey = "";
    if (allKeys.length > 0) {
      allKeys.forEach(singleKey => {

        let splitStr = singleKey.split(':');
        let descKey = this.cryptoSer.decryptData(splitStr[1], splitStr[0]);
        if (!descKey.startsWith('error')) {
          if (key === descKey)
            validKey = singleKey;
        }

      });
    }
    return validKey;

  }
}
